import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4v16","key":"svg-0"}],["path",{"d":"M8 6h12","key":"svg-1"}],["path",{"d":"M8 12h6","key":"svg-2"}],["path",{"d":"M8 18h10","key":"svg-3"}]]

const IconAlignLeft2 = createReactComponent('outline', 'align-left-2', 'AlignLeft2', __iconNode);

export default IconAlignLeft2;